import { render, staticRenderFns } from "./paciente.vue?vue&type=template&id=5e6788c5"
import script from "./paciente.vue?vue&type=script&lang=js"
export * from "./paciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports